module.exports = "../fonts/HelveticaNeueLTW01-45Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-45Light.woff
// module id = r0Zh
// module chunks = 1